import ReactDOM from 'react-dom';
import React, { useEffect, useState } from 'react';
import {
  ADDED_TO_CART_EVENT_MODAL,
  isCartApiCheckoutButtonEnabled,
  isLoopReturnsActive,
  useCartData,
} from '../../../../utils/cart';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { ApolloProvider, useLazyQuery } from '@apollo/client';
import PGWCarousel from '../PairsGreatWith/PairsGreatWithCarousel';
import CircularProgress from '@material-ui/core/CircularProgress';
import { loader } from 'graphql.macro';
import { AddedToCartProduct } from './types';
import { closeDesktopSearch, closeMobileSearch } from 'src/scripts/sections/header/initializeHeaderScripts';
import { UrgencyMessage } from '../../../product/components/ScarcityMessaging/UrgencyMessage';
import { productServiceClient } from '../../apolloClientUtils';
import { isLocal, isProductServiceAvailable } from 'src/scripts/utils/environment';
import { useMediaQuery } from '@material-ui/core';
import { MUI_DESKTOP_BREAKPOINT } from 'src/scripts/utils/constants';
import './styles.scss';
import { Gifts } from '../../../../sections/header/Cart/components/GWP/Gifts';
import { checkIfInVariation } from '../../../../utils/optimizely';
import { find } from 'lodash-es';
import { getSizeNumbers } from 'src/scripts/templates/product/components/VariantSelections/helpers';
import { checkIfItemCanBeSoldOut } from 'src/scripts/utils/helpers';
import { currentPathEquals, prependLocaleToPath } from '../../../../utils/localization';
import ErrorBoundary from 'src/scripts/utils/react/ErrorBoundary';
import CartCheckoutButton from 'src/scripts/sections/header/Cart/components/CartCheckoutButton';
import { formatShopifyPrice } from 'src/scripts/sections/header/Cart/components/helpers';
const RecommendedProductsQuery = loader(
  './../RecommendedProductsCarousel/GetRecommendedProducts.product-service.graphql'
);

const ATCModal = () => {
  // Forced variation preview: https://www.aloyoga.com/collections/womens-leggings?optimizely_x=25236720165&optimizely_token=PUBLIC
  const IS_GWP_CAROUSEL_ENABLED = checkIfInVariation({ variationId: '25236720165', experimentId: '25240460083' });

  const isDesktop = useMediaQuery(MUI_DESKTOP_BREAKPOINT, { noSsr: true });
  const [isOpen, setIsOpen] = useState(false);
  const [data, setData] = useState<AddedToCartProduct | null>(null);
  const toggle = () => setIsOpen((isOpen) => !isOpen);
  const cartData = useCartData();

  useEffect(() => {
    const openModal = (e: Event) => {
      // ? [REVISIT] figure how to type annotate CustomEvents properly (without 'as')
      const eventData = e as CustomEvent<AddedToCartProduct>;
      setData(eventData.detail);
    };

    document.addEventListener(ADDED_TO_CART_EVENT_MODAL, openModal);
    return () => {
      document.removeEventListener(ADDED_TO_CART_EVENT_MODAL, openModal);
    };
  }, []);

  const [
    getRecommmendedProducts,
    { loading: recommmendedProductsLoading, data: recommmendedProductsData, error: RSerror },
  ] = useLazyQuery(RecommendedProductsQuery);

  if (RSerror) {
    console.log(RSerror);
  }

  useEffect(() => {
    if (data) setIsOpen(true);
    try {
      // ? [REVISIT] move some of this (related products) logic into a helper function /  component
      if (data) {
        const shouldHideRelatedCarousel = !isProductServiceAvailable;

        if (!shouldHideRelatedCarousel) {
          const doNotRecommendProductIds = cartData.regularItems.map((item) => item.product_id.toString());
          const selectedSize = data.options_with_values.find((option) => option.name.toLowerCase() === 'size')?.value;
          const variables = {
            productId: data.product_id.toString(),
            first: 10,
            ...(selectedSize
              ? {
                  sizeNameInStock: selectedSize,
                  recommendationScheme: 'pgw_2021_a',
                  doNotRecommend: doNotRecommendProductIds,
                }
              : { recommendationScheme: 'pgw_2021_a', doNotRecommend: doNotRecommendProductIds }),
          };
          getRecommmendedProducts({
            variables,
          });
        }
      }
    } catch (err) {
      console.log(err);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, getRecommmendedProducts]);

  const viewBagAction = (event: React.MouseEvent<HTMLElement>) => {
    if (currentPathEquals('/cart')) {
      event?.preventDefault();
      isDesktop ? closeDesktopSearch() : closeMobileSearch();
    } else {
      window.location.href = prependLocaleToPath('/cart');
    }
    toggle();
  };

  const color =
    find(data?.options_with_values, (obj) => obj.name === 'Color' && obj.value.toLowerCase() !== 'no color')?.value ??
    '';
  const size =
    find(data?.options_with_values, (obj) => obj.name === 'Size' && obj.value.toLowerCase() !== 'one size')?.value ??
    '';
  const length = find(data?.options_with_values, (obj) => obj.name === 'Length')?.value ?? '';

  const isGiftCard = data?.product_type.toLowerCase().includes('gift card');
  const giftProductLabel = isGiftCard ? 'Amount' : 'Size';
  const sizeMappedInfo = data?.product_type && getSizeNumbers(size, data.product_type, data?.sku);

  const baseTitle = data?.product_title.replace(` - ${color}`, '');
  const unlimitedInventory = !checkIfItemCanBeSoldOut(data?.tags);

  const itemCount = cartData.count;
  const itemLabel = itemCount === 1 ? 'item' : 'items';
  const formattedCartSubtotal = formatShopifyPrice(cartData.subtotal);

  return (
    data && (
      <div>
        <Modal
          isOpen={isOpen}
          toggle={toggle}
          onClosed={() => setData(null)}
          centered
          returnFocusAfterClose={false}
          className="atc-modal"
        >
          <ModalHeader toggle={toggle}>Added to Bag</ModalHeader>
          <ModalBody>
            <div className="atc-modal-item">
              <img className="img-fluid d-md-block" src={data?.featured_image.url} alt="" />
              <div className="atc-modal-item-info">
                <div className="message">
                  <p className="product-title body-large">{baseTitle}</p>
                  {color ? (
                    <p className="product-description body">
                      Color: <span className="body bold">{color}</span>
                    </p>
                  ) : null}
                  {size ? (
                    <p className="product-description body">
                      {giftProductLabel}:{' '}
                      <span className="body bold">
                        {size} {sizeMappedInfo}
                      </span>
                    </p>
                  ) : null}
                  {length ? (
                    <p className="product-description body">
                      Length: <span className="body bold">{length}</span>
                    </p>
                  ) : null}
                  {!unlimitedInventory && (
                    <UrgencyMessage quantityLeft={data.quantityAvailable} className="atc-modal" />
                  )}
                </div>
              </div>
            </div>
            <div className="subtotal-and-buttons">
              <div className="subtotal-section">
                <p className="subtotal_text body-large">
                  Order Subtotal ({itemCount} {itemLabel}):{' '}
                  <span className="body-large bold" data-currency>
                    {formattedCartSubtotal}
                  </span>
                </p>
              </div>
              <div className={`cart-path-buttons`}>
                <button className="atc-view-bag-button" onClick={viewBagAction}>
                  View bag
                </button>
                {isCartApiCheckoutButtonEnabled ? (
                  <CartCheckoutButton
                    options={{
                      buttonClasses: 'atc-checkout-button',
                      showSpinner: false,
                    }}
                  />
                ) : (
                  <button
                    className="atc-checkout-button"
                    onClick={() => {
                      if (!isLoopReturnsActive()) {
                        window.location.href = prependLocaleToPath('/checkout');
                      }
                      toggle();
                    }}
                  >
                    Checkout
                  </button>
                )}
              </div>
            </div>
          </ModalBody>
          {IS_GWP_CAROUSEL_ENABLED && <Gifts isNewDesign ATBtype="ATC modal GWP Carousel" />}
          {(recommmendedProductsLoading || recommmendedProductsData) && (
            <ModalFooter className="custom-modal-footer">
              {recommmendedProductsLoading ? (
                <div className="loading__block mt-5 pt-md-5 mb-5 pb-md-5">
                  <div className="d-flex justify-content-center">
                    <CircularProgress color="inherit" />
                  </div>
                  <p className="large-p mt-2">Loading products you might like...</p>
                </div>
              ) : null}
              {recommmendedProductsData ? <PGWCarousel data={recommmendedProductsData} /> : null}
            </ModalFooter>
          )}
        </Modal>
      </div>
    )
  );
};

export default ATCModal;

export const renderAtcModal = () => {
  // Rendering (long term it's a good idea to seperate the rendering from as the component)
  ReactDOM.render(
    <ErrorBoundary key={(!isLocal || new Date()).toString()}>
      <ApolloProvider client={productServiceClient}>
        <ATCModal />
      </ApolloProvider>
    </ErrorBoundary>,
    document.getElementById('ATCmodalReactContainer')
  );
};
